module.exports = __webpack_public_path__ + "7f82708133410fea6137ccf509e0e04c.svg";